import { CardType } from '../../types/cardType';

export const noInput = [
  CardType.Agmo,
  CardType.ApplePay,
  CardType.AstropayWallet,
  CardType.Awepay,
  CardType.BankWire,
  CardType.Bizum,
  CardType.Boku,
  CardType.CashFree,
  CardType.CashFreeMobileWallet,
  CardType.CashFreeNetBanking,
  CardType.CashFreeUpi,
  CardType.EcoPayZ,
  CardType.EnvoyRtbt,
  CardType.Eps,
  CardType.Euteller,
  CardType.Giropay,
  CardType.GooglePay,
  CardType.HiPay,
  CardType.Ideal,
  CardType.IDebit,
  CardType.InstaDebit,
  CardType.InstantBank,
  CardType.Interac,
  CardType.LuxonPay,
  CardType.MBookOBT,
  CardType.Multibanco,
  CardType.MobilePay,
  CardType.NeosurfHosted,
  CardType.Now2PayMobile,
  CardType.Now2PayWeb,
  CardType.PagoEfectivo,
  CardType.Payconiq,
  CardType.PayMoney,
  CardType.PayNearMe,
  CardType.PaySafe,
  CardType.Paytm,
  CardType.PSIOB,
  CardType.Rtbt,
  CardType.SafetyPay,
  CardType.SberBank,
  CardType.Sofort,
  CardType.StarsWallet,
  CardType.TicketPremium,
  CardType.TrustPay,
  CardType.Vanilla,
  CardType.VivaPayments,
  CardType.WebMoney,
  CardType.WirecardWbt,
  CardType.YandexMoney,
  CardType.InovapayHosted,
  CardType.Klarna
];

export const noInputSaved: CardType[] = [
  CardType.Bancontact,
  CardType.LuxonPay,
  CardType.MBookers,
  CardType.MobilePayment,
  CardType.MuchBetter,
  CardType.MBWay,
  CardType.Neteller2,
  CardType.OpenBanking,
  CardType.PayPal,
  CardType.Pay4Fun,
  CardType.Payconiq,
  CardType.Pix,
  CardType.ProfeeCards,
  CardType.ProfeeMobilepayment,
  CardType.ProfeeQiwi,
  CardType.ProfeeWallet,
  CardType.ProfeeYandex,
  CardType.QiwiWallet,
  CardType.Skrill1Tap,
  CardType.Solo,
  CardType.Swish
];
export const isBankTransfer = (type: CardType) =>
  [CardType.EnvoyLbt, CardType.BankWire, CardType.Multibanco].includes(type);

export const creditTimeInstant = [CardType.OpenBanking, CardType.Payconiq];

export const creditTimeMinutes = [
  CardType.ApplePay,
  CardType.AstropayWallet,
  CardType.Bancontact,
  CardType.Boku,
  CardType.CashFree,
  CardType.CashFreeMobileWallet,
  CardType.CashFreeNetBanking,
  CardType.CashFreeUpi,
  CardType.CreditCard,
  CardType.DebitCard,
  CardType.ECheck,
  CardType.EPay,
  CardType.EcoPayZ,
  CardType.Eps,
  CardType.Euteller,
  CardType.GamersCard,
  CardType.Giropay,
  CardType.GooglePay,
  CardType.InovapayHosted,
  CardType.InstaDebit,
  CardType.InstantBank,
  CardType.LuxonPay,
  CardType.MBWay,
  CardType.MBookOBT,
  CardType.MBookers,
  CardType.MasterCard,
  CardType.MuchBetter,
  CardType.Multibanco,
  CardType.MobilePay,
  CardType.NemkontoCashout,
  CardType.Neosurf,
  CardType.NeosurfHosted,
  CardType.Neteller2,
  CardType.OpenBanking,
  CardType.PSIOB,
  CardType.PStarsTopUp,
  CardType.Pay4Fun,
  CardType.PayNearMe,
  CardType.PayPal,
  CardType.PaySafe,
  CardType.Paytm,
  CardType.Pix,
  CardType.QiwiWallet,
  CardType.Resort,
  CardType.Ricarica,
  CardType.SightlineNR,
  CardType.Skrill1Tap,
  CardType.Sofort,
  CardType.Solo,
  CardType.TicketPremium,
  CardType.Todito,
  CardType.VanillaDirect,
  CardType.Visa,
  CardType.WebMoney,
  CardType.Klarna
];

export const creditTimeDays = [
  CardType.BankWire,
  CardType.BoletoAstropay,
  CardType.BoletoInovapay,
  CardType.EnvoyLbt,
  CardType.WirecardWbt
];

export const creditTimeHours = [CardType.EnvoyRtbt, CardType.Interac, CardType.SafetyPay];
export const creditTimeTwoDays = [CardType.PsPayInovapay];

export const redirectMethods = [
  CardType.AstropayWallet,
  CardType.Bizum,
  CardType.Bancontact,
  CardType.CashFree,
  CardType.CashFreeMobileWallet,
  CardType.CashFreeNetBanking,
  CardType.CashFreeUpi,
  CardType.EPay,
  CardType.EcoPayZ,
  CardType.EnvoyRtbt,
  CardType.Eps,
  CardType.Giropay,
  CardType.InovapayHosted,
  CardType.InstaDebit,
  CardType.InstantBank,
  CardType.Interac,
  CardType.LuxonPay,
  CardType.MBookOBT,
  CardType.MBookers,
  CardType.NemkontoCashout,
  CardType.NeosurfHosted,
  CardType.Neteller2,
  CardType.Pay4Fun,
  CardType.PayPal,
  CardType.PaySafe,
  CardType.Paytm,
  CardType.ProfeeCards,
  CardType.ProfeeMobilepayment,
  CardType.ProfeeQiwi,
  CardType.ProfeeWallet,
  CardType.ProfeeYandex,
  CardType.Rtbt,
  CardType.SafetyPay,
  CardType.Sofort,
  CardType.TicketPremium,
  CardType.WebMoney,
  CardType.YandexMoney,
  CardType.Klarna
];

export const customRedirectMethods = [
  CardType.BankWire,
  CardType.MasterCard,
  CardType.MBWay,
  CardType.MuchBetter,
  CardType.OpenBanking,
  CardType.PStarsTopUp,
  CardType.PsPayAstropay,
  CardType.PsPayInovapay,
  CardType.Ricarica,
  CardType.Visa
];

export const alwaysSaveMethods = [CardType.AstropayWallet, CardType.LuxonPay];

export const alwaysMakeFastDepositMethods = [CardType.LuxonPay];

export const customHelpMethods = [
  CardType.AstropayWallet,
  CardType.BoletoAstropay,
  CardType.BoletoInovapay,
  CardType.ECheck,
  CardType.GamersCard,
  CardType.MBookers,
  CardType.MBWay,
  CardType.MuchBetter,
  CardType.Neteller2,
  CardType.Pay4Fun,
  CardType.PStarsTopUp,
  CardType.Ricarica,
  CardType.Skrill1Tap,
  CardType.Todito
];
